$(document).ready(function () {
  $(".prd-collapse-btn").on("click", function () {
    const $clickedItem = $(this).closest(".prd-collapse-item");
    const $content = $clickedItem.find(".prd-collapse-content");

    if ($clickedItem.hasClass("prd-collapse-item-ac")) {
      $clickedItem.removeClass("prd-collapse-item-ac");
      $content.stop(true, true).slideUp(300);
    } else {
      $(".prd-collapse-item").removeClass("prd-collapse-item-ac");
      $(".prd-collapse-content").stop(true, true).slideUp(300);

      $clickedItem.addClass("prd-collapse-item-ac");
      $content.stop(true, true).slideDown(300);
    }
  });
});

if (window.innerWidth <= 991) {
  $(".prd-media-grid").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
}

$(".sibling-prd-slider").slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
// ON CLICK VARIANT ADD/REMOVE CLASS SCRIPT START
$(".spc-prd-swatch-block").click(function () {
  $(this).siblings().removeClass("spc-prd-swatch-block-ac");
  $(this).addClass("spc-prd-swatch-block-ac");
});

// ON CLICK VARIANT CHANGE IMAGE IN PRODUCT CARD
document.querySelectorAll(".spc-prd-swatch-block").forEach(function (swatch) {
  swatch.addEventListener("click", function () {
    const newImg = swatch.getAttribute("data-img");
    const card = swatch.closest(".simple-prd-card");

    if (newImg && card) {
      const imgTag = card.querySelector(".spc-img-wrapper img");
      imgTag.setAttribute("src", newImg);
    }
    card.querySelectorAll(".spc-prd-swatch-block").forEach(function (el) {
      el.classList.remove("spc-prd-swatch-block-ac");
    });
    swatch.classList.add("spc-prd-swatch-block-ac");
  });
});

function updateVariantId() {
  var selectedOptions = [];

  // 1. Get first variant option from active button (like Color)
  var firstOption = $(".pdp-variant-btn.active").data("variant");
  if (firstOption) {
    selectedOptions.push(firstOption.toLowerCase().replace(/\s+/g, ""));
  }

  // 2. Get the rest of the options from dropdowns (like Size, etc.)
  $(".variant-dropdown").each(function () {
    var val = $(this).val();
    if (val) {
      selectedOptions.push(val.toLowerCase().replace(/\s+/g, ""));
    }
  });

  // 3. Join all selected values to form the variant key
  var variantKey = selectedOptions.join("");
  var variantId = $('input[name="' + variantKey + '"]').val();

  // 4. Set the variant ID into the hidden input field
  if (variantId) {
    $("input.product-variant-id").val(variantId);
  } else {
    console.warn("Variant not found for:", variantKey);
  }
}

// Handle click on variant buttons
$(document).on("click", ".pdp-variant-btn", function () {
  $(this).addClass("active").siblings().removeClass("active");
  updateVariantId();
});

// Handle dropdown changes
$(document).on("change", ".variant-dropdown", function () {
  updateVariantId();
});

// Handle button click for first variant option
$(".pdp-variant-btn").click(function () {
  var data_variant = $(this).attr("data-variant");

  // Update label next to first variant option
  $(this)
    .closest(".prd-variants")
    .find(".variant-dropdown")
    .first()
    .closest(".prd-variants")
    .find(".prd-variant-label")
    .first()
    .find("span")
    .text(data_variant);
});

// Handle select change for dropdowns
$(".variant-dropdown").change(function () {
  var selected_option = $(this).val();

  // Update label for this specific dropdown
  $(this)
    .closest(".prd-variants")
    .find(".prd-variant-label")
    .eq($(this).data("var") - 1) // use `data-var` to match correct label
    .find("span")
    .text(selected_option);
});
